import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import AuthenticatedRoutes from "./components/AuthenticatedRoutes";
import Legal from "./components/Legal";
import PrivacyPolicy from "./components/Privacypolicy";
import Footer from "./components/Footer";
import InstructionPage from "./components/InstructionPage";
import Userform from "./components/Userform";
import Thankyou from "./components/Thankyou";
import { onAuthStateChanged } from "firebase/auth";
import { auth, firestore } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

// Helper to check if the current URL is a public form-taking route
function isPublicFormRoute() {
  const path = window.location.pathname;
  return (
    /\/form\/[^/]+$/.test(path) ||
    /\/form\/[^/]+\/instructions\/userform/.test(path) ||
    /\/form\/[^/]+\/userform\/submit/.test(path) ||
    /\/form\/[^/]+\/thankyou/.test(path)
  );
}

function App() {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsSignedIn(true);
        setUserId(user.uid);
        sessionStorage.setItem("userId", user.uid);
        sessionStorage.setItem("email", user.email);
        sessionStorage.setItem("photoURL", user.photoURL);
      } else {
        // Always update the route state after sign-out. The previous loading
        // guard kept authenticated routes mounted and left /signin blank.
        setIsSignedIn(false);
        setUserId(null);
        sessionStorage.clear();
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userId) {
      const userDocRef = doc(firestore, "userprofilemaster", userId);
      getDoc(userDocRef).then((snapshot) => {
        if (snapshot.exists() || isPublicFormRoute()) {
          //
        } else {
          if (window.location.pathname !== "/signup") {
            window.location.href = "/signup";
          }
        }
      });
    }
  }, [userId]);

  if (loading && !isPublicFormRoute()) {
    return null; // or return a loading spinner
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, paddingBottom: 44 }}>
        <Routes>
          {/* Public routes — accessible without authentication */}
          {!isSignedIn && <Route path="/form/:id" element={<InstructionPage />} />}
          <Route path="/form/:id/instructions/userform" element={<InstructionPage />} />
          <Route path="/form/:id/userform/submit" element={<Userform value={sessionStorage.getItem("email") || ""} />} />
          <Route path="/form/:id/thankyou" element={<Thankyou />} />

          {/* Legal routes */}
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* Authenticated routes */}
          {isSignedIn ? (
            <Route
              path="*"
              element={
                <AuthenticatedRoutes
                  photoURL={sessionStorage.getItem("photoURL")}
                  value={sessionStorage.getItem("email")}
                  name={sessionStorage.getItem("name")}
                />
              }
            />
          ) : (
            <Route path="*" element={<Signin />} />
          )}
          <Route path="/signup" element={<Signup />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
